module.exports = __webpack_public_path__ + "img/pv-v2.97a102cc.svg";